import React from 'react'
import { Form } from 'react-bootstrap'
import { useBoardCheckboxChange } from './useBoardCheckboxChange'
import { truncate } from '@ztechapps/common.utils'

export const BoardCheckbox = ({ name, _id, remarks, checked }) => {
  const onBoardCheckboxChange = useBoardCheckboxChange()

  return (
    <Form.Check
      type="checkbox"
      id={_id}
      onChange={() => onBoardCheckboxChange({ _id, checked })}
      value={checked}
      label={
        <>
          <div>{truncate(name, 40)}</div>
          <small>{truncate(remarks, 50)} </small>
        </>
      }
    />
  )
}
